export default __webpack_public_path__ + "25479a71d8f8b889b956c3345d63908a.png";